import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root',
  })
export class ScheduleStateService {
    public isStateChanged = new BehaviorSubject<boolean>(false);
    currentMessage = this.isStateChanged.asObservable();
  
    constructor() { }
  
    changeScheduleState(isSaveSucceeded: boolean) {
      this.isStateChanged.next(isSaveSucceeded)
    }
    }
  